import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-preco-padrao',
  templateUrl: './preco-padrao.component.html',
  styleUrls: ['./preco-padrao.component.scss']
})
export class PrecoPadraoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/produto-components/produto/preco-padrao/preco-padrao.component.ts